<template>
	<div>
		<div id="qrcode" v-show="false"/>
		<img id="jsbarcode" v-show="false"/>
	</div>
</template>

<script>
	import config from '@/config';

	const h5PageUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.h5PageDev : config.baseUrl.h5PagePro;
	const JsBarcode = require("jsbarcode");
	const qrcode = require("qrcodejs2");
	import {getPrintTemplate} from '@/api/sorting/sorting';
	import {queryBoxListDetailByOrder} from "@/api/sorting/packingBox";
	import {queryPreSortingByIds} from '@/api/sorting/preSorting';
	import {changeUnit,getHasSortingUnitAndBaseUnit} from "@/libs/util";
    import { printByTemplate, printByTemplateV2 } from "../util/printUtil";

	const timeUtil = require("../libs/timeUtil");

	export default {
		name: "globalPrint",
		props: {},
		data() {
			return {
				printInfoSe: {},
			};
		},
		methods: {
			// TODO 预分拣打印
			async printPreSorting(printDatas) {
				if (printDatas && printDatas.length) {
					let printInfoSe = this.printInfoSe;
					if (!printInfoSe || !printInfoSe.hasOwnProperty("prefenjianPrint")) {
						return this.$Notice.error({
							title: "请先前往设置中心绑定预分拣标签打印机", render: h => {
								return h('div', [
									h('a',
										{
											on: {
												click: () => {
													this.$router.push({name: "setting"});
												}
											}
										},
										"前往配置"
									),
								])
							}
						});
					}

					let param = {type: 14};
					// 判断是否绑定模板
					if (printInfoSe.prefenjianPrintTemplate) {
						param = {id: printInfoSe.prefenjianPrintTemplate};
					}


					// 查询预分拣模板
					let printTemplate = await this.getPrintTemplate(param);

					let allDatas = await queryPreSortingByIds({ids: printDatas});
					if (allDatas && allDatas.data.code == 1200 && allDatas.data.data && allDatas.data.data.length) {
						let result = allDatas.data.data;
						// 循环打印预分拣标签
						for (let i = 0; i < result.length; i++) {
							let printItem = result[i];
							// 打印码添加预制字段
							printItem.id = 'P'+printItem.id;
							document.getElementById("jsbarcode").setAttribute("src", "");
							JsBarcode("#jsbarcode", printItem.id, {displayValue: false});
							let barcodeBase64 = document.getElementById("jsbarcode").getAttribute("src");
							let qr;
							if (this.$store.state.platform_setting && this.$store.state.platform_setting.moduleArr.includes("traceSource")) {
								document.getElementById("qrcode").innerHTML = "";
								qr = new qrcode("qrcode", {
									text: h5PageUrl + "/s/#/?s=" + printItem.id,
									width: 80,
									height: 80,
									colorDark: "#000000",
									colorLight: "#ffffff",
									correctLevel: qrcode.CorrectLevel.L
								});
							}
							// TODO 格式化打印数据
							await this.lwPromise();
							console.log(printItem)
							let showValue = getHasSortingUnitAndBaseUnit({
								weightG:printItem.is_weight==1?printItem.weight:printItem.pack_count,
								base_unit:printItem.unit,
								unit:printItem.auxiliary_unit,
								unit_conversion: printItem.unit_conversion,
								is_weight:printItem.is_weight
							}).showUnit;

							let printData = {
								sort_no: printItem.sort_no,
								sort_number: showValue,
								specifications: printItem.auxiliary_unit,
								sku_name: printItem.sku_name,
								sourceCode: "",
								sorter_name: printItem.creater_name,
								print_time: timeUtil.dateFormat(timeUtil.getFullDate(), "MM/DD HH:mm"),
								barcode: barcodeBase64,
								barcode_text: printItem.id,
							};
							if (printData.is_weight == 1)
								printData.sort_number = changeUnit(printData.weight, "g", "斤") + "斤";
							if (qr) {
								printData.sourceCode = qr._oDrawing._elImage.src;
							}
							if(printTemplate.template_grade == 2){ // 新版打印
								printData.barcode = printItem.id;
								printByTemplateV2(printTemplate.printTemplate, [printData], printInfoSe.prefenjianPrint);
							}else{
								printByTemplate("预分拣标签" + timeUtil.getTimeStamp(), 1, printInfoSe.prefenjianPrint, printData, printTemplate);
							}
						}
					} else {
						return this.$Notice.error({title: "打印异常"});
					}

					// 循环打印预分拣标签
					// for (let i = 0; i < printDatas.length; i++) {
					// 	let printData = printDatas[i];
					// 	printByTemplate("预分拣标签" + timeUtil.getTimeStamp(), 1, printInfoSe.prefenjianPrint, printData, printTemplate,1);
					// }
				}
			},
			// 箱签打印
			async printPackingBox(printDatas) {
				if (printDatas && printDatas.length) {
					let printInfoSe = this.printInfoSe;
					if (!printInfoSe || !printInfoSe.hasOwnProperty("packingBoxPrint")) {
						return this.$Notice.error({
							title: "请先前往设置中心绑定装箱标签打印机", render: h => {
								return h('div', [
									h('a',
										{
											on: {
												click: () => {
													this.$router.push({name: "setting"});
												}
											}
										},
										"前往配置"
									),
								])
							}
						});
					}

					let param = {type: 13};
					// 判断是否绑定模板
					if (printInfoSe.packingBoxPrintTemplate) {
						param = {id: printInfoSe.packingBoxPrintTemplate};
					}
					let printTemplate = await this.getPrintTemplate(param);

					for (let i = 0; i < printDatas.length; i++) {
						let param = {
							orderId: printDatas[i].orderId,
							boxId: printDatas[i].boxId,
							// box_no: printDatas[i].box_no
						};
						queryBoxListDetailByOrder(param).then(data => {
							if (data.data.code == 1200) {
								let packingBoxDatas = data.data.data.datas;
								let printData = {
									box_no_title: packingBoxDatas[0].box_no_title,
									shopname: packingBoxDatas[0].deliver_user_name,
									reciver_name: packingBoxDatas[0].reciver_name,
									reciver_phone: packingBoxDatas[0].reciver_phone,
									inner_no: packingBoxDatas[0].inner_no,
									printTime: timeUtil.dateFormat(timeUtil.getFullDate(), "YYYY/MM/DD HH:mm"),
									productCount: packingBoxDatas.length,
								};
								let tableData = [];
								for (let i = 0; i < packingBoxDatas.length; i++) {
									let specifications = packingBoxDatas[i].product_cache ? packingBoxDatas[i].product_cache.specifications : "";
									let data = {
										index: i + 1,
										productName: packingBoxDatas[i].product_name,
										productCount: packingBoxDatas[i].product_num + specifications,
										real_count: packingBoxDatas[i].real_count + specifications,
										remark: packingBoxDatas[i].order_note,
									};
									if (packingBoxDatas[i].is_weight == 1)
										data.real_count = changeUnit(packingBoxDatas[i].weight, "g", "斤") + "斤";
									tableData.push(data);
								}
								printData.tableData = tableData;
                if(printTemplate.template_grade == 2){ // 新版打印
                  printByTemplateV2(printTemplate.printTemplate, [printData], printInfoSe.packingBoxPrint);
                }else{
                  printByTemplate("装箱标签" + timeUtil.getTimeStamp(), 1, printInfoSe.packingBoxPrint, printData, printTemplate);
                }
							} else {
								return this.$Notice.error({title: "打印异常"});
							}
						}).catch(err => {
							console.log(err);
						});
					}
				}
			},
			// 获取模板数据
			async getPrintTemplate(param) {
				let tempdata = await getPrintTemplate(param);
				if (tempdata.data.code == 1200) {
					let printTemplate = {
						page: tempdata.data.data.page,
						type: tempdata.data.data.type,
						printTemplate: tempdata.data.data.print_template,
            template_grade: tempdata.data.data.template_grade
					};
					return printTemplate;
				}
				return null;
			},
			lwPromise() {
				let promise = new Promise((resolve, reject) => {
					setTimeout(() => {
						resolve()
					}, 100);
				})
				return promise
			}
		},
		created() {
			let printInfoSe = localStorage.getItem("printSet");
			if (printInfoSe) {
				this.printInfoSe = JSON.parse(printInfoSe);
			}
		},
		mounted() {
		},
		destroyed() {
		},
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/globalPrint.vue